export * from './isMobile';
export { default } from './isMobile';
